import { useState, useEffect, ComponentType } from 'react';
import { LOADER_TIME_OUT } from 'common/config/constant';

//add 1 cái loader vào mọi page, sẽ ẩn đi sau 1 khoảng thời gian
export function withLoader(Component: ComponentType) {
  return function WrappedComponent(props: any) {
    const [showLoader, setShowLoader] = useState(true);

    useEffect(() => {
      const timer = setTimeout(() => setShowLoader(false), LOADER_TIME_OUT); // Adjust delay as needed
      return () => clearTimeout(timer);
    }, []);

    return (
      <>
        {showLoader && <Loader />}
        <Component {...props} />
      </>
    );
  };
}

//loader chính
export const Loader = () => {
  return (
    <div className="fixed left-0 top-0 w-screen h-screen flex justify-center items-center z-50 backdrop-blur-sm">
      <div className="flex-col gap-4 w-full flex items-center justify-center">
        <div className="w-20 h-20 border-4 border-transparent text-blue-400 text-4xl animate-spin flex items-center justify-center border-t-blue-400 rounded-full">
          <div className="w-16 h-16 border-4 border-transparent text-red-400 text-2xl animate-spin flex items-center justify-center border-t-red-400 rounded-full" />
        </div>
      </div>
    </div>
  );
};
